import {Injectable} from '@angular/core';
import {throwError} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';

declare let emit: any;

@Injectable({
  providedIn: 'root'
})
export class InventarProvider {

   private url = '';
   private urlCouch = '';

  constructor(public http: HttpClient) { }

  setInventarDbName(dbName: any): void {
    localStorage.setItem('inventarDbName', dbName);
  }

  getInventarDbName(): string {
    const name = localStorage.getItem('inventarDbName');
    if (name) {
      return name;
    } else {
      return '';
    }
  }

  setUrl(url) {
      this.url = url;
      this.urlCouch = url.replace('_service', '_couch');
  }

  setInventarLoginData(token: string, pass: string) {
    localStorage.setItem('authInventar', token + ':' + pass);
  }

  logoutInvntar(): void {
    localStorage.removeItem('inventarDbName');
    localStorage.removeItem('authInventar');
  }

  getInventarLoginData() {
    const data = localStorage.getItem('authInventar');
    if (data) {
      const sp = data.split(':');
      return {username: sp[0], password: sp[1]};
    } else {
      return false;
    }
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  putItem(item) {

    const db = localStorage.getItem('inventarDbName');

    const url = this.urlCouch + '/' + db + '/' + item._id;
    return this.putData(url, 'Basic', item);
  }

  searchEan(ean): Promise<any> {

    const db = localStorage.getItem('inventarDbName');

    return new Promise((resolve, reject) => {
      const ddoc: any = {
        _id: '_design/hnrSearch',
        views: {
          inventarEan : {
            // tslint:disable-next-line:only-arrow-functions
            map: function(doc: any) {
              if (doc.type === 'inventar') {
                emit(doc.ean, {_id : doc._id, objectCount: 0});
              }
            }.toString()
          }
        }
      };

      this.putData(this.urlCouch + '/' + db + '/_design/hnrSearch', 'Basic' , ddoc).then(() => {
        const url = this.urlCouch + '/' + db + '/_design/hnrSearch/_view/inventarEan';
        this.getData(url, 'Basic', {limit: 101, startkey: '"' + ean + '"', endkey: '"' + ean + '"', include_docs: 'true'}).then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
      }).catch((err) => {
        const url = this.urlCouch + '/' + db + '/_design/hnrSearch/_view/inventarEan';
        this.getData(url, 'Basic', {limit: 101, startkey: '"' + ean + '"', endkey: '"' + ean + '"', include_docs: 'true'}).then((res) => {
          resolve(res);
        }).catch((err2) => {
          reject(err2);
        });
      });
    });

  }



  searchById(id: string) {
    const db = localStorage.getItem('inventarDbName');
    const url = this.urlCouch + '/' + db + '/' + id;
    return this.getData(url, 'Basic', {include_docs: 'true'});
  }

  getPerson() {
    const db = localStorage.getItem('inventarDbName');
    const url = this.urlCouch + '/' + db + '/_design/getAll/_view/person';
    return this.getData(url, 'Basic', {include_docs: 'true'});
  }

  postData(personData: any) {
    const db = localStorage.getItem('inventarDbName');
    const url = this.urlCouch + '/' + db;
    return this.http.post(url, personData, {headers: this._getAuthHeader('Basic').headers, withCredentials: true});
  }

  loginCall(username: string, password: string) {
    return new Promise<void>((resolve, reject) => {

        if (!this.url) {
            reject('InventarServerUrl nicht gesetzt');
            return;
        }

        username = unescape(encodeURIComponent(username.toLowerCase()));
        password = unescape(encodeURIComponent(password));

        this.http.post(this.url + '/auth/login', {username, password}).pipe(
          map(data => this._toJson(data)),
          catchError(this._handleError)
        ).subscribe({next:(res: any) => {
          localStorage.setItem('user_id', res.user_id);
          localStorage.setItem('buyData', JSON.stringify(res.profile.buyData));

          const dbKeys = Object.keys(res.userDBs);
          const newDbName = res.userDBs[dbKeys[0]].substr(res.userDBs[dbKeys[0]].lastIndexOf('/') + 1);

          this.setInventarLoginData(res.token, res.password);
          this.setInventarDbName(newDbName);

          resolve();
        }, error:(err) => {
          reject(err);
        }});
    });
  }

  private _getAuthHeader(type= 'Bearer'): any {
    const auth: any = this.getInventarLoginData();
    let authString = '';
    if (type === 'Bearer') {
      authString = auth.username + ':' + auth.password;
    } else {
      authString = window.btoa(auth.username + ':' + auth.password);
    }
    return {
      headers: new HttpHeaders({
        Authorization: type + ' ' + authString
      })
    };
  }

  private putData(url: string, type= 'Bearer', params: any= {}): Promise<any> {
    return new Promise((resolve, reject) => {

      if (!this.url) {
          reject('InventarServerUrl nicht gesetzt');
          return;
      }

      this.http.put(url, params , {headers: this._getAuthHeader(type).headers, withCredentials: true}).pipe(
        map(data => this._toJson(data)),
        catchError(this._handleError)
      ).subscribe({next:(res: any) => {
          resolve(res);
        }, error:(err) => {
          reject(err);
        }});
    });
  }

  private getData(url: string, type= 'Bearer', params: any= {}): Promise<any> {
    return new Promise((resolve, reject) => {

      if (!this.url) {
          reject('InventarServerUrl nicht gesetzt');
          return;
      }

      this.http.get(url, {headers: this._getAuthHeader(type).headers, params}).pipe(
        map(data => this._toJson(data)),
        catchError(this._handleError)
      ).subscribe({next:(res: any) => {
          resolve(res);
        }, error:(err) => {
          reject(err);
        }});
  });
  }

  public getInventarUserData() {
    return this.getData(this.url + '/auth/user');
  }

  forgotInventarPWD(email: any) {
    return new Promise((resolve, reject) => {

        if (!this.url) {
            reject('InventarServerUrl nicht gesetzt');
            return;
        }

        this.http.post(this.url + '/auth/forgot-password', {email}).pipe(
          map(data => this._toJson(data)),
          catchError(this._handleError)
        ).subscribe({next:(res: any) => {
              resolve(res);
            }, error:(err) => {
              debugger;
              reject(err);
            }});
    });
  }

  private _toJson(data: any) {
    try{
      return data.json();
    } catch (e) {
      return data;
    }
  }

  private _handleError(error: Response | any) {
    let err: any;
    try {
      err = JSON.parse(error._body);
    } catch (e) {
      err = {error: error._body};
    }
    return throwError(err || 'Server error');
  }


}
